"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
var useStyles = (0, _core.makeStyles)({
  paper: {
    width: '600px',
    paddingTop: '32px',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    padding: '116px 53px 0 53px'
  },
  headerTitle: {
    '& > h2': {
      lineHeight: '30px'
    }
  },
  headerSubtitle: {
    '& > span': {
      color: 'rgba(52,52,52,0.5)',
      fontWeight: 500,
      letterSpacing: '2px'
    }
  },
  close: {
    '&:hover': {
      cursor: 'pointer'
    },
    display: 'inline-block',
    border: '0',
    backgroundColor: 'transparent',
    margin: '32px 24px 0',
    position: 'absolute',
    right: '0px',
    top: '0px',
    outline: 0,
    '& > svg': {
      color: '#C3C3C3',
      width: '22px !important',
      height: '22px !important'
    }
  },
  lineBreak: {
    backgroundColor: 'rgba(112,112,112,0.2)',
    width: '100%',
    height: '1px',
    border: 'none'
  },
  v1Close: {
    margin: '88px 24px 0 !important'
  },
  v1Paper: {
    paddingTop: '58px !important'
  }
});
exports.useStyles = useStyles;